import { actions as betsHistoryBasketContainerActions } from 'containers/BetsHistoryBasketContainer/slice'

export const betsHistoryProviderSideEffects = {
  betsHistoryBasket: {
    onSuccess: betsHistoryBasketContainerActions.fetchHistoryBetsBasketSuccess,
    onError: betsHistoryBasketContainerActions.fetchHistoryBetsBasketError
  }
}
